import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=209c8d32&"
import script from "./Pagina.vue?vue&type=script&lang=js&"
export * from "./Pagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports